import {Element} from './element';

export class Folder {
  constructor(public id: number,
              public name: string,
              public kit_id: number,
              public elements?: Element[]
  ) {}
}

export interface IRawFolder {
  id: number;
  name: string;
  kit_id: number;
}

export function mapFolder(rawFolder: IRawFolder) {
  return new Folder(rawFolder.id, rawFolder.name, rawFolder.kit_id, []);
}


// WEBPACK FOOTER //
// ./src/app/services/folder.ts